import { Component, EventEmitter, Inject, Input, Output } from '@angular/core';
import { Observable } from 'rxjs';
import { SubjectRelay } from '../../../../shared/commands/subject-relay.class';
import { AccesService } from '../services/acces.service';
import { NotificationForCC } from '../entities/notification-for-cc.entity';

import { UserService } from '../../../humain/user/services/user.service';
import { UserTLR } from '../../../humain/user/entities/user-tlr.entity';

@Component({
    selector: 'notif-fermeture-acces',
    templateUrl: 'notif-fermeture-acces.html',
    styleUrls: ['notif-fermeture-acces.css'],
})
export class NotificationFermetureAccesComponent {

    sortedMetasNotifications: NotificationForCC[] = [];
    private resfreshDataCommands = new SubjectRelay();

    private user!: UserTLR;

    @Input() set refreshCommands(obs: Observable<void> | null) {
        this.resfreshDataCommands.registerSource(obs);
    }

    @Output() stateTransitionNeeded = new EventEmitter<void>();

    constructor(@Inject(AccesService) private accesService: AccesService, @Inject(UserService) private userService: UserService) {
		userService.getCurrentUserTLR().subscribe(
			(user) => {
				this.user = user;
				this.loadNotifications();
			}
		);
		this.resfreshDataCommands.asObservable().subscribe(() => {
            this.loadNotifications();
        });
    }

    private loadNotifications(): void {
		if (this.user) {
			console.log('loading event notifications for user: ', this.user);
	        this.accesService.getCCNotifEvents(this.user.id).subscribe(
				(notifications: NotificationForCC[]) => {
	                this.sortedMetasNotifications = notifications;
	        	}
			);
		}
    }

	ok(notification: NotificationForCC): void {
	    this.accesService.markCcNotifAsViewed(notification.id)
	        .subscribe((notifications: NotificationForCC[]) => {
	            this.sortedMetasNotifications = notifications;
	        });
	}
	
	formatTypeAcces(typeAcces: string): string {
		switch (typeAcces) {
			case 'LOCAL':
				return 'Local';
			case 'A_DISTANCE':
				return 'A Distance';
			default:
				return typeAcces;
		}
	}
}